import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { dateToFirestoreTimestamp } from 'shared/services/backend-api/converters/date-to-firestore-timestamp';
import { UpdateTask } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';

import {
  BatchDocuments,
  CollectionOptions,
  getAuthentication,
  getCollection,
  getDatabase,
} from './helpers';

export const updateTasks = async (tasks: UpdateTask[]) => {
  // Get the currently authenticated user
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const taskCollection = getCollection(CollectionOptions.Tasks);

  if (tasks.length === 1) {
    // if only one task is being updated, we can use updateDoc directly
    updateDoc(doc(taskCollection, tasks[0].id), {
      ...dateToFirestoreTimestamp(tasks[0]),
      updatedAt: serverTimestamp() as unknown as Timestamp,
    });
    return;
  }

  const batchDocuments = new BatchDocuments(getDatabase());

  tasks.forEach((updateTask) => {
    batchDocuments.updateDocument({
      ref: doc(taskCollection, updateTask.id),
      data: {
        ...dateToFirestoreTimestamp(updateTask),
        updatedAt: serverTimestamp() as unknown as Timestamp,
      },
    });
  });

  batchDocuments.commit();
};
